module.exports = __webpack_public_path__ + "img/design.99660f87.png";